'use strict';

module.exports = ['$scope', function ($scope) {

    // ------------------
    // Scope functions
    // ------------------

    // ------------------
    // Load Dependent Data
    // ------------------


    // ------------------
    // Initialization
    // ------------------
    $scope.plant_types = [
        { name: "Aggregate", value: "Aggregate" },
        { name: "Mix", value: "Mix" },
    ];

}];

